import { Moment } from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  showErrorToast,
  showSuccessToast,
} from '../../../../../../common/global/helpers';
import useBreakpoints from '../../../../../../common/hooks/useBreakpoints';
import Dialog from '../../../../../../common/widgets/Dialog';
import Icons from '../../../../../../common/widgets/Icons';
import { Timesheet } from '../../../../models/TimeAndAttendance';
import { resources } from '../../../../resources/resources';
import { timeAndAttendanceService } from '../../../../services/time-and-attendance';

interface ISubmitTimesheetDialogProps {
  currentDate: Moment;
  setShowSubmitTimesheetDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setTimesheet: React.Dispatch<React.SetStateAction<Timesheet[] | undefined>>;
}

export const SubmitTimesheetDialog = (props: ISubmitTimesheetDialogProps) => {
  const { isMobile } = useBreakpoints();
  const { t: translate } = useTranslation();

  const handleSubmitTimesheet = async () => {
    const abortController = new AbortController();

    const result = await timeAndAttendanceService.submitTimesheet(
      props.currentDate,
      {
        signal: abortController?.signal,
      },
    );

    if (!result.hasErrors) {
      if (!result.hasErrors) {
        showSuccessToast(
          translate(resources.timeAndAttendance.submitTimesheet.successMessage),
        );
        props.setShowSubmitTimesheetDialog(false);

        props.setTimesheet(undefined);

        const timesheetsResult = await timeAndAttendanceService.getTimesheet(
          props.currentDate,
        );

        if (!timesheetsResult.hasErrors) {
          props.setTimesheet(timesheetsResult.data);
        } else {
          showErrorToast(translate(resources.errors.generic));
        }
      } else {
        showErrorToast(
          translate(resources.timeAndAttendance.submitTimesheet.errorMessage),
        );
        props.setShowSubmitTimesheetDialog(false);
      }
    }
  };

  return (
    <Dialog
      className={`dialog-m taa-dialog ${isMobile && 'mobile-dialog'}`}
      showCloseIcon={true}
      closeOnClickOutside={false}
      closeDialog={() => {
        props.setShowSubmitTimesheetDialog(false);
      }}
    >
      <div className="taa-confirm-container">
        <div>{<Icons.HelpRed />}</div>
        <h2>
          {translate(
            resources.timeAndAttendance.submitTimesheet.confirmation.title,
          )}
        </h2>
        <p>
          {translate(
            resources.timeAndAttendance.submitTimesheet.confirmation
              .description,
          )}
        </p>

        <div className="taa-confirm-actions">
          <button className="btn btn-solid" onClick={handleSubmitTimesheet}>
            <span className="btn-text">
              {translate(
                resources.timeAndAttendance.submitTimesheet.confirmation.finish,
              )}
            </span>
          </button>
          <button
            className="btn btn-outline"
            onClick={() => props.setShowSubmitTimesheetDialog(false)}
          >
            <span className="btn-text">
              {translate(
                resources.timeAndAttendance.submitTimesheet.confirmation.back,
              )}
            </span>
          </button>
        </div>
      </div>
    </Dialog>
  );
};
